import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { Resource } from '@opentelemetry/resources';
import { SemanticResourceAttributes } from '@opentelemetry/semantic-conventions';
import { CompositePropagator, W3CTraceContextPropagator, W3CBaggagePropagator } from '@opentelemetry/core';
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import {
    LoggerProvider,
    SimpleLogRecordProcessor
} from '@opentelemetry/sdk-logs';
import { OTLPLogExporter } from '@opentelemetry/exporter-logs-otlp-http';

const resourceSettings = new Resource({
    [SemanticResourceAttributes.SERVICE_NAME]: 'h2u-react',
});

const buildOtelHeaders = (): Record<string, string> => {
    const headers: Record<string, string> = {};
    const otelAuth =
        process.env.REACT_APP_OTEL_AUTH_HEADER ||
        process.env.REACT_APP_INSTRUMENTED_AUTH;
    if (otelAuth) {
        headers['Authorization'] =
            otelAuth.startsWith('Basic ') || otelAuth.startsWith('Bearer ')
                ? otelAuth
                : `Bearer ${otelAuth}`;
    }
    if (process.env.REACT_APP_OTEL_HEADERS) {
        try {
            const parsed = JSON.parse(process.env.REACT_APP_OTEL_HEADERS);
            Object.assign(headers, parsed);
        } catch {
            // Ignore malformed custom headers JSON
        }
    }
    return headers;
};

const otelHeaders = buildOtelHeaders();

const loggerProvider = new LoggerProvider({
    resource: resourceSettings
});

loggerProvider.addLogRecordProcessor(new SimpleLogRecordProcessor(new OTLPLogExporter({
    url: process.env.REACT_APP_INSTRUMENTED_ENDPOINT ? process.env.REACT_APP_INSTRUMENTED_ENDPOINT + '/v1/logs' : 'http://15.222.237.20:4318/v1/logs',
    headers: otelHeaders,
    keepAlive: true,
})));

const traceExporter = new OTLPTraceExporter({
    url: process.env.REACT_APP_INSTRUMENTED_ENDPOINT ? process.env.REACT_APP_INSTRUMENTED_ENDPOINT + '/v1/traces' : 'http://15.222.237.20:4318/v1/traces',
    headers: otelHeaders
});

const provider = new WebTracerProvider({ resource: resourceSettings });

provider.addSpanProcessor(new BatchSpanProcessor(traceExporter));

provider.register({
    contextManager: new ZoneContextManager(),
    propagator: new CompositePropagator({
        propagators: [new W3CBaggagePropagator(), new W3CTraceContextPropagator()],
    }),
});

const startOtelInstrumentation = () => {
    registerInstrumentations({
        tracerProvider: provider,
        instrumentations: [
            getWebAutoInstrumentations({
                '@opentelemetry/instrumentation-xml-http-request': {
                    enabled: true,
                    clearTimingResources: true,
                    propagateTraceHeaderCorsUrls: [new RegExp(process.env.REACT_APP_DJANGO_ALPHA_ENDPOINT || 'http://localhost:8000')],
                    applyCustomAttributesOnSpan: (span, request) => {
                        span.updateName(`${request.responseURL} ${request.statusText}`);
                    },
                },
                '@opentelemetry/instrumentation-fetch': {
                    propagateTraceHeaderCorsUrls: [new RegExp(process.env.REACT_APP_DJANGO_ALPHA_ENDPOINT || 'http://localhost:8000')],
                    enabled: true,
                    applyCustomAttributesOnSpan: (span, request) => {
                        if (request instanceof Request) {
                            span.updateName(`${request.method} ${request.url}`);
                        }
                    },
                },
                '@opentelemetry/instrumentation-document-load': {
                    enabled: true,
                },
                '@opentelemetry/instrumentation-user-interaction': {
                    eventNames: [],
                },
            }),
        ],
    });
};

export { startOtelInstrumentation, buildOtelHeaders };
export const loggerOtel = loggerProvider.getLogger('default');
